export default defineAppConfig({
  ui: {
    primary: 'orange',
    gray: 'cool',
    
    // Base text colors
    text: {
      base: 'text-gray-900 dark:text-gray-100',
      muted: 'text-gray-700 dark:text-gray-300',
      light: 'text-gray-600 dark:text-gray-400'
    },

 

    // Input
    input: {
      default: {
        size: 'lg',
        outline: 'shadow-sm bg-white dark:bg-gray-900/50 text-gray-900 dark:text-white ring-1 ring-gray-100/80 dark:ring-gray-800/40 hover:ring-gray-200/60 dark:hover:ring-gray-700/40 focus:ring-2 focus:ring-orange-500/60 dark:focus:ring-orange-400/60 transition-all duration-200 rounded-xl'
      },
      base: 'relative block w-full disabled:bg-gray-50/50 disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none border-0',
      form: 'form-input',
      rounded: 'rounded-lg',
      placeholder: 'placeholder-gray-400 dark:placeholder-gray-500',
      padding: {
        '2xs': 'px-2 py-1',
        'xl': 'text-base px-6 py-3 gap-3 justify-center'
      },
      size: {
        '2xs': 'text-xs',
        'xs': 'text-xs',
        'sm': 'text-sm',
        'md': 'text-sm',
        'lg': 'text-sm',
        'xl': 'text-sm'
      }
    },

    // Card
    card: {
      base: ' transition-all duration-200',
      background: 'bg-white dark:bg-gray-900',
      divide: 'divide-y divide-gray-100/60 dark:divide-gray-800/40',
      ring: '',
      rounded: 'border border-gray-200',
      shadow: '',
      
      body: {
        base: 'flex-1',
        background: '',
        padding: 'p-5 sm:p-6',
        color: 'text-gray-900 dark:text-white'
      },
      header: {
        base: 'relative  border-b border-gray-200/60 !overflow-hidden',
        padding: 'px-5 py-4 sm:px-6',
        color: 'text-gray-900 dark:text-white ',
        title: 'text-base font-semibold',
        description: 'mt-1 text-sm text-gray-500 dark:text-gray-400',
        wrapper: 'flex items-center justify-between gap-4'
      },
      footer: {
        base: 'relative border-t border-gray-100/60 dark:border-gray-800/40',
        background: 'bg-gradient-to-t from-gray-50/50 to-transparent dark:from-gray-800/20 dark:to-transparent',
        padding: 'px-5 py-4 sm:px-6',
        color: 'text-gray-700 dark:text-gray-300'
      }
    },

    // Select
    select: {
      base: 'relative block w-full disabled:bg-gray-50/50 disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none border-0 ',
      variant: {
        custom: 'shadow bg-white dark:bg-gray-900/50 h-10 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-800/40 hover:border-gray-300 dark:hover:border-gray-700/40 focus:ring-2 focus:ring-orange-500/60 dark:focus:ring-orange-400/60 transition-all duration-200 rounded-lg'
      },
      placeholder: 'text-gray-400 dark:text-gray-500',
      default: {
        variant: 'custom'
      }
    },

    // Prose
    prose: {
      base: 'prose dark:prose-invert max-w-none',
      font: 'font-normal',
      color: {
        base: 'text-gray-900 dark:text-gray-100',
        muted: 'text-gray-700 dark:text-gray-300'
      }
    },

    textarea: {
      variant: {
        custom:
          "shadow-sm bg-white text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-{color}-400 focus:ring-2 focus:ring-{color}-500 dark:focus:ring-{color}-400",
      },
      default: {
        color: "orange",
        variant: "custom",
      },
    },
    button: {
      default: {
        size: 'lg',
        color: 'orange',
        base: 'flex items-center justify-center gap-2 transition-all duration-200',
        padding: 'px-4 py-2',
        font: 'font-medium',
        rounded: 'rounded-xl',
      },
      size: {
        '2xs': 'text-xs px-2 py-1 gap-1 justify-center',
        'xs': 'text-xs px-2.5 py-1.5 gap-1 justify-center',
        'sm': 'text-sm px-3 py-2 gap-2 justify-center',
        'md': 'text-sm px-4 py-2 gap-2 justify-center',
        'lg': 'text-sm px-5 py-2.5 gap-2 justify-center',
        'xl': 'text-base px-6 py-3 gap-3 justify-center',
      },
      
    },
    table: {
      wrapper: 'min-w-full bg-white dark:bg-gray-900/50 rounded-xl shadow-sm',
      base: 'min-w-full table-fixed',
      thead: 'bg-gray-50/50 dark:bg-gray-800/30',
      tr: 'hover:bg-gray-50/30 dark:hover:bg-gray-800/20 focus:bg-gray-50/30 dark:focus:bg-gray-800/20 border-b border-gray-100/60 dark:border-gray-800/40 last:border-none transition-colors',
      th: {
        base: 'text-left rtl:text-right whitespace-nowrap',
        padding: 'px-4 py-3.5',
        color: 'text-gray-600 dark:text-gray-400',
        font: 'font-medium text-sm',
        size: ''
      },
      td: {
        base: 'whitespace-nowrap',
        padding: 'px-4 py-4',
        color: 'text-gray-600 dark:text-gray-400',
        font: 'text-sm'
      },
      loadingState: {
        wrapper: 'flex flex-col items-center justify-center flex-1 gap-3 py-12',
        label: 'text-sm text-gray-600',
        icon: 'w-6 h-6 text-gray-400 animate-spin'
      },
      emptyState: {
        wrapper: 'flex flex-col items-center justify-center flex-1 gap-3 py-12',
        label: 'text-sm text-gray-600',
        icon: 'w-6 h-6 text-gray-400'
      },
      sort: {
        icon: 'i-heroicons-arrows-up-down-20-solid',
        margin: 'ml-2',
        size: '14px',
        button: {
          icon: 'i-heroicons-arrows-up-down-20-solid',
          color: 'gray',
          variant: 'ghost',
          size: 'xs'
        }
      }
    }
  },
});
